<!--
=========================================================================================
    Message Card
==========================================================================================
-->

<template>
  <div>         
    <vx-card>   
      <ChatUI :activator="[]" slot="no-body" />
    </vx-card>  
  </div>        
</template>     
                
<script>        
import ChatStoreModule from "@/store/modules/chat";
                
export default {
  components: { 
    ChatUI: () => import("@/developing/components/chat")
  },            
  props: {      
    message: {  
      type: Object,
      required: true
    }           
  },            
  beforeCreate() {
    if (!this.$store.state.Chat) this.$store.registerModule("Chat", ChatStoreModule);
  }             
}               
</script>       
                